// extracted by mini-css-extract-plugin
export default {"tabList":"Ti9JzRL5j2ffj7_I37F8"};